// extracted by mini-css-extract-plugin
module.exports = {"containerClasses":"breadcrumb_containerClasses__V9myU","crumb":"breadcrumb_crumb__vWcKA"};